import { Typography, Box, SxProps, Theme, useTheme } from '@mui/material';
import { Breadcrumbs } from '@shared/components';
import { GoBackLink } from '@dap/common/ui';

export interface Breadcrumb {
  label: string | React.ReactNode;
  href?: string;
  relativePath?: boolean;
}

interface Props {
  breadcrumbs?: Breadcrumb[];
  header?: string;
  sx?: SxProps<Theme>;
  backLink?: string;
}

export default function SanityPageHeader({ breadcrumbs, header, sx, backLink }: Props) {
  const { breakpoints } = useTheme();

  return (
    <Box sx={sx}>
      <GoBackLink href={backLink} />
      {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}

      {!!header && (
        <Typography variant="h2" component="h1" sx={{ mt: 5, [breakpoints.down('md')]: { mt: 3 } }}>
          {header}
        </Typography>
      )}
    </Box>
  );
}
